class CustomCartDrawer extends HTMLElement {
    constructor() {
        super();

        this.openTrigger = document.querySelector(`#${this.dataset.openTrigger}`);
        this.overlay = this.querySelector("#CustomCartOverlay");
        this.closeButton = this.querySelector("[data-close]");
        this.cartCount = document.querySelector(".cart-items-count")
    }

    connectedCallback() {
        this.openTrigger?.addEventListener("click", this.handleOpen.bind(this));
        this.closeButton?.addEventListener("click", this.closeDrawer.bind(this));
        document.addEventListener("click", (event) => {            
            if(event.target === this.overlay) {
                this.closeDrawer();
            }
        })

        document.addEventListener("cart:rerender", this.cartRerender.bind(this));
    }

    handleOpen(event) {
        event.preventDefault();
        this.openDrawer();
    }

    openDrawer() {
        this.setAttribute("open", "");
    }

    closeDrawer() {
        this.removeAttribute("open");
    }

    // cartRerender(event) {
    //     const sectionHTML = event.detail.sections["custom-cart-drawer"];        
    //     const cartCountHtml = event.detail.sections["custom-cart-count"];        

    //     if (!sectionHTML) return;

    //     // Parse new HTML
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(sectionHTML, "text/html");

    //     const newDrawer = doc.querySelector("custom-cart-drawer");

    //     if (!newDrawer) return;

    //     // Replace only inner content (not the root element)
    //     this.innerHTML = newDrawer.innerHTML;

    //     // Re-bind important elements (because DOM replaced)
    //     this.overlay = this.querySelector("#CustomCartOverlay");
    //     this.closeButton = this.querySelector("[data-close]");

    //     this.closeButton?.addEventListener("click", this.closeDrawer.bind(this));
    //     this.overlay?.addEventListener("click", () => this.closeDrawer());

    //     // Open drawer after update
    //     this.openDrawer();
    // }

    cartRerender(event) {
        const sectionHTML = event.detail.sections["custom-cart-drawer"];
        const cartCountHtml = event.detail.sections["custom-cart-count"];

        /* ---------------- DRAWER UPDATE ---------------- */
        if (sectionHTML) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHTML, "text/html");

            const newDrawer = doc.querySelector("custom-cart-drawer");

            if (newDrawer) {
                this.innerHTML = newDrawer.innerHTML;

                // re-bind after DOM replace
                this.overlay = this.querySelector("#CustomCartOverlay");
                this.closeButton = this.querySelector("[data-close]");

                this.closeButton?.addEventListener(
                    "click",
                    this.closeDrawer.bind(this)
                );

                this.overlay?.addEventListener("click", () =>
                    this.closeDrawer()
                );

                this.openDrawer();
            }
        }

        /* ---------------- CART COUNT UPDATE ---------------- */
        if (cartCountHtml && this.cartCount) {
            const parser = new DOMParser();
            const countDoc = parser.parseFromString(cartCountHtml, "text/html");

            const newCount = countDoc.querySelector(".cart-items-count");

            if (newCount) {
                this.cartCount.textContent = newCount.textContent.trim();
            }
        }
    }
}

customElements.define("custom-cart-drawer", CustomCartDrawer);

class AtcButton extends HTMLElement {
    constructor() {
        super();        
        this.submitForm = this.querySelector("form[action='/cart/add']");
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    get sectionId() {
        return this.dataset.sectionId;
    }

    // connectedCallback() {
    //     // this.variantPicker = this.querySelectorAll('select[name="id"]');
    //     this.variantPicker = this.querySelectorAll('.x-product__variant-select');

    //     this.submitForm.addEventListener("submit", this.handleSubmit);

    //     if (this.variantPicker?.length > 0) {
    //         const boundHandler = this.handleChnage.bind(this);

    //         this.variantPicker.forEach(function (element) {
    //             element.addEventListener("change", boundHandler);
    //         });
    //     }
    // }

    connectedCallback() {

    this.variantPicker =
    this.querySelectorAll('.x-product__variant-select');

    this.submitForm.addEventListener(
        "submit",
        this.handleSubmit
    );

    if (this.variantPicker.length > 0) {

        const boundHandler =
        this.handleChnage.bind(this);

        this.variantPicker.forEach((element) => {

            element.addEventListener(
                "change",
                boundHandler
            );

        });

    }

}

    // handleChnage(event) {
    //     const select = event.currentTarget;
    //     // const url = `${window.location.pathname}?variant=${select.value}&section_id=${this.sectionId}`;

    //     const url = new URL(window.location.href);

    //     url.searchParams.set('variant', select.value);

    //     const sectionUrl =
    //     `${url.pathname}${url.search}&section_id=${this.sectionId}`;
        
    //     fetch(sectionUrl)
    //     .then(response => {
    //         return response.text();
    //     })
    //     .then(html => {
    //         const tempDiv = document.createElement("div");
    //         tempDiv.innerHTML = html;
            
    //         document.querySelector(".x-product__container").innerHTML =
    //          tempDiv.querySelector(".x-product__container").innerHTML;

    //          window.history.replaceState({}, '', url.toString());

    //         //  window.initializeProductGallery?.();
    //         requestAnimationFrame(() => {
    //             window.initializeProductGallery?.();

    //             const selectedVariant =
    //             tempDiv.querySelector('select[name="id"]')?.value;

    //             if (selectedVariant) {

    //                 const currentUrl = new URL(window.location.href);

    //                 currentUrl.searchParams.set('variant', selectedVariant);

    //                 window.history.replaceState({}, '', currentUrl.toString());
    //             }
    //         });
    //     })
    // }

    handleChnage() {
        console.log("hande change called..")
    /*
    -----------------------------------
    GET SELECTED OPTIONS
    -----------------------------------
    */

    const selectedOptions = [];

    this.querySelectorAll('.x-product__variant-select')
    .forEach(select => {
        selectedOptions.push(select.value);
    });

    /*
    -----------------------------------
    FIND MATCHING VARIANT
    -----------------------------------
    */

    const matchedVariant = window.productVariants.find(variant => {

        return variant.options.every((option, index) => {
            return option === selectedOptions[index];
        });

    });

    if (!matchedVariant) return;

    /*
    -----------------------------------
    UPDATE HIDDEN INPUT
    -----------------------------------
    */

    const hiddenInput = this.querySelector('input[name="id"]');

    if (hiddenInput) {
        hiddenInput.value = matchedVariant.id;
    }

    /*
    -----------------------------------
    UPDATE URL
    -----------------------------------
    */

    const url = new URL(window.location.href);

    url.searchParams.set('variant', matchedVariant.id);

    const sectionUrl =
    `${url.pathname}${url.search}&section_id=${this.sectionId}`;

    /*
    -----------------------------------
    FETCH SECTION HTML
    -----------------------------------
    */

    fetch(sectionUrl)

    .then(response => response.text())

    .then(html => {

        const tempDiv = document.createElement('div');

        tempDiv.innerHTML = html;

        const newContainer =
        tempDiv.querySelector('.x-product__container');

        document.querySelector('.x-product__container').innerHTML =
        newContainer.innerHTML;

        /*
        -----------------------------------
        UPDATE URL
        -----------------------------------
        */

        window.history.replaceState({}, '', url.toString());

        /*
        -----------------------------------
        RE-INIT SWIPER
        -----------------------------------
        */

        requestAnimationFrame(() => {

            window.initializeProductGallery?.();

        });

    });

}
    
    handleSubmit(event) {
        event.preventDefault();

        const button = this.submitForm.querySelector('button[type="submit"]');

        // prevent double click
        if (button.classList.contains('loading')) return;

        button.classList.add('loading');

        let variantId = this.submitForm.querySelector('input[name="id"]')?.value;

        if(!variantId) {
            variantId = this.submitForm.querySelector('select[name="id"]')?.value;
        }

        console.log(variantId, 'variant id here...')

        let formData = {
            'items': [{
                'id': variantId,
                'quantity': this.submitForm.querySelector('input[name="quantity"]').value
            }],
            'sections': "custom-cart-drawer,custom-cart-count"
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            document.documentElement.dispatchEvent(
                new CustomEvent("cart:rerender", {
                    detail: data,
                    bubbles: true
                })
            )
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            // restore button
            button.classList.remove('loading');
        });
    }

}

customElements.define("atc-button", AtcButton);

class CartActions extends HTMLElement {
    constructor() {
        super();

        this.plusButton = this.querySelector("[data-plus]")
        this.minusButton = this.querySelector("[data-minus]")
        this.removeButton = this.querySelector("[data-remove]")
    }

    connectedCallback() {
        this.plusButton.addEventListener("click", this.handleChnage.bind(this))
        this.minusButton.addEventListener("click", this.handleChnage.bind(this))
        this.removeButton.addEventListener("click", this.handleChnage.bind(this))
    }

    handleChnage(event) {

        const item = this.closest('.x-cart__item');

        // prevent multiple clicks
        if (item.classList.contains('loading')) return;

        item.classList.add('loading');

        const formData = {
            "line": this.dataset.line,
            // "quantity": event.target.dataset.quantity,
            quantity: event.target.closest('button').dataset.quantity,
            "sections": "custom-cart-drawer,custom-cart-count"
        }

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            document.documentElement.dispatchEvent(
                new CustomEvent("cart:rerender", {
                    detail: data,
                    bubbles: true
                })
            )
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            // fallback (in case rerender is slow)
            item.classList.remove('loading');
        });

    }
}

customElements.define("cart-actions", CartActions);